// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module__list___16GwE","item":"styles-module__item___1DQh9","bullet":"styles-module__bullet___1hEuQ","text":"styles-module__text___1sJDH"};